module.exports = __webpack_public_path__ + "img/9788983944894.887dbc6e.jpg";